var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "position-relative" }, [
    _c(
      "div",
      {
        staticClass: "position-absolute",
        staticStyle: { top: "0", right: "0" },
      },
      [
        _c(
          "button-loader",
          { attrs: { loading: _vm.loading } },
          [
            _c(
              "b-dropdown",
              {
                attrs: {
                  id: "swap-applicants-dropdown",
                  variant: "white",
                  "toggle-class": "btn-sm",
                  right: "",
                  disabled: _vm.disableSwap,
                },
                scopedSlots: _vm._u([
                  {
                    key: "button-content",
                    fn: function () {
                      return [
                        _c("span", { staticClass: "bold d-sm-inline d-none" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("application.swapApplicant.dropdownText")
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "i",
                          { staticClass: "material-icons d-block d-sm-none" },
                          [_vm._v("more_vert")]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _vm._v(" "),
                _c("b-dropdown-header", { staticClass: "d-block d-sm-none" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("application.swapApplicant.dropdownText")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _vm._l(_vm.applicantsDetails, function (applicant) {
                  return _c(
                    "b-dropdown-item",
                    {
                      key: applicant.applicantIndex,
                      on: {
                        click: function ($event) {
                          return _vm.handleSwapConfirm(applicant)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(applicant.fullName) +
                          "\n        "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.selectedApplicant
          ? _c("swap-application-confirmation-modal", {
              ref: "modal",
              attrs: {
                "selected-applicant-name": _vm.selectedApplicant.fullName,
                loading: _vm.loading,
              },
              on: { hidden: _vm.handleModalHidden, submit: _vm.handleSwap },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }